import React, { useEffect } from 'react';

const IosPage = () => {
    useEffect(() => {
        window.location.replace("https://apps.apple.com/us/app/mosaic-club/id1550480681");
    }, []);

    return (
        <>
        </>
    );
}

export default IosPage;